import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/es5/locale/en';
import ar from 'vuetify/es5/locale/ar';

Vue.use(Vuetify);

export default new Vuetify({
	rtl: true,
	theme: {
		themes: {
			light: {
				primary: '#114673',
				secondary: '#2979FF',
				accent: '#1565C0',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107'
			},
		},
		dark: false,
	},
	lang: {
		locales: {
			en,
			ar
		},
		current: 'ar'
	}
});
